<template>
      <div>
      <swipe class="my-swipe">
        <swipe-item class="slide1"></swipe-item>
         <swipe-item class="slide2"></swipe-item>
        <!-- <swipe-item class="slide2"></swipe-item>
        <swipe-item class="slide3"></swipe-item>
        <swipe-item class="slide4"></swipe-item> -->
      </swipe>
      <!-- <button class="startKnow" @click="startKnowClick">了解客户端</button> -->
      <!-- <div class="my-swipe" style="margin-bottom:60px;"><img src="@/assets/img/new_banner.jpg" alt=""></div> -->
      <div class="mobile-banner">
        <!-- <img src="~@/assets/img/index_img/mobile_banner.png" alt=""> -->
      </div>
      </div>
</template>

<script>
   export default {
    data() {
      return {
        swiperOption: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    methods: {
      startKnowClick () {
        window.location.href="https://hsdl.tiaozhuan.com/HelpsContent?id=5be0fca52fe6bb268817c43a&title=Windows%E7%AB%AF"
        setTimeout(function(){
          window.location.href = "https://hsdl.tiaozhuan.com/HelpsArticle?title=Windows%E5%AE%A2%E6%88%B7%E7%AB%AF%E4%BD%BF%E7%94%A8%E6%95%99%E7%A8%8B&subId=5be1007a2fe6bb461f3309f6"
        },1000)
      }
    }
  }
</script>

<style lang="stylus">
@import 'vue-swipe/dist/vue-swipe.css';
.my-swipe
  height 585px
  color #fff
  font-size 30px
  text-align center
.mint-swipe-indicators
  display none;
.startKnow
  position absolute
  left 19%
  top  370px
  border none
  background none
  color #fff
  width 158px
  height 48px
  line-height 48px
  margin-top 60px
  font-size 22px
  color #00FFB2
  letter-spacing 0px
  border 1px solid #00FFB2
  border-radius 24px
  cursor pointer
  &:hover,:active{
    background #07d597
    color #fff
    border none
  }
.slide1 {
  background-size: cover;
  background-position: center;
  background-image:url('~@/assets/img/new_banner.jpg');
}

.slide2 {
  background-size: cover;
  background-position: center;
  background-image:url('~@/assets/img/huasheng_banner2.png');
}

.slide3 {
  background-size: cover;
  background-position: center;
  background-image:url('~@/assets/img/huasheng_banner3.jpg');
}

.slide4 {
  background-size: cover;
  background-position: center;
  background-image:url('~@/assets/img/huasheng_banner4.jpg');
}

>>> .swiper-button-prev, .swiper-button-next
  height 100%
  width 100px
  margin-top -290px
>>> .swiper-pagination-bullet
  transition all .3s ease-in
>>> .swiper-pagination-bullet-active
  background: #007afc;
  width: 25px;
  border-radius: 30px;
.mobile-banner
  display none
.swiper-container {
  background-color: #000;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  height 580px
  &.slide-1 {
    background-size: cover;
    background-position: center;
    background-image:url('~@/assets/img/huasheng_banner1.jpg');
  }
  &.slide-2 {
    background-size: cover;
    background-position: center;
    background-image:url('~@/assets/img/huasheng_banner2.jpg');
  }
  &.slide-3 {
    background-size: cover;
    background-position: center;
    background-image:url('~@/assets/img/huasheng_banner3.jpg');
  }
}
.gallery-top {
  height: 80%!important;
  width: 100%;
}
.gallery-thumbs {
  height: 20%!important;
  box-sizing: border-box;
  padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
@media screen and (max-width: 768px)
  .swiper-slide
    height 375px
  .startKnow
    left 50%
    margin-left -79px
@media screen and (max-width: 456px)
  .startKnow
    left 50%
    margin-left -79px
  .my-swipe
    display none
  .swiper-container
    display none
  .mobile-banner
    display block
  .mobile-banner
    background url("~@/assets/img/index_img/mobile_banner.png")
    height 420px
    background-repeat no-repeat
  .swiper-slide
    height 200px
    background-size cover
  >>> .swiper-button-next,.swiper-button-prev
    width 20px
    height 20px
</style>



// WEBPACK FOOTER //
// src/pages/Home/components/banner1.vue